<template>
  <div class="container-fluid mt-2">
    <h2>Daten-Graphen</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <button id="new" @click="addDataGraph()" class="btn btn-primary">Hinzuf&uuml;gen</button>
    </div>
    <b-table no-local-sorting @sort-changed="updateSort" @row-clicked="open" class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(action)="data">
        <button @click="deleteGraph(data.item)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
      </template>
    </b-table>
  </div>
</template>

<script>
import router from '@/router'
import datagraph from '@/modules/datagraph.js'

export default {
  name: 'DataTablesView',
  data() {
    return {
      fields: [
        { key: "id", label: "ID" },
        { key: 'name', label: 'Name' },
        { key: 'action', label: 'Aktion' }
      ],
      start: 0,
      count: 20,
      rows: [],
    }
  },
  mounted: function() {
    this.fetchData();
  },
  methods: {
    nextPage() {
      this.start += this.count;
      this.fetchData();
    },
    prevPage() {
      if (this.start > 0) {
        this.start -= this.count;
        this.fetchData();
      }
    },
    fetchData: function() {
        console.log('fetch graph data');
      var self = this;
      datagraph.list(this.start,this.count).then((data) => {
        console.log('new rows:',data);
        self.rows = data;
      });
    },
    open: function(row) {
      console.log('open');
      router.push({name:'DataGraphEditor',params:{ id:row.id }});
    },
    addDataGraph: function() {
      router.push({name:'DataGraphEditor',params: {id: 0}});
    },
    deleteGraph(item) {
        console.log('delete row: ',item);
    }
  }
}
</script>
